module.exports = "/dist/c9bfcdf2d50d8c1b333f957cb1e12d7c.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400.eot
// module id = 12
// module chunks = 0